export default {
  es: {
    operation: 'Operación',
    create: 'Crear rol',
    edit: 'Editar rol',
    deleteRole: '¿Estás seguro de eliminar este rol?',
    rolCreated: 'Un nuevo rol ha sido creado',
    rolUpdated: 'Un rol ha sido actualizado',
    rolDeleted: 'Un rol ha sido eliminado'
  },
  en: {
    operation: 'Operation',
    create: 'Create role',
    edit: 'Edit role',
    deleteRole: 'Do you want to delete this rol?',
    rolCreated: 'A new role have been created',
    rolUpdated: 'A role have been updated',
    rolDeleted: 'A role have been deleted'
  }
};
